module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-76x76-4c550b32f9901ae208e0e0f1e7956545.png";